import { Component} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-download-app-banner',
  templateUrl: './download-app-banner.component.html',
  styleUrls: ['./download-app-banner.component.scss']
})
export class DownloadAppBannerComponent {

}



